import React, {useEffect, useState, useRef} from "react"
import EditIcon from "@mui/icons-material/PhotoCamera"
import {getOrientation, isTouchDevice, resetOrientation} from "../../lib/util"
import IconButton from "@mui/material/IconButton"
// import { updateProfilePhoto } from '../../actions'
import {useSelector, useDispatch} from "../../store";
import {useAuth} from "../../hooks/use-auth";
import {Fade, Box} from "@mui/material";
import {updateProfilePhoto} from "../../slices/user-session-slice";
import {PhotoCropAndUploadDialog} from "../photo-crop-and-upload-dialog";
import {useTheme} from "@mui/material/styles";

export const ProfilePhoto = () => {

    const theme = useTheme()

    const [shouldShowEdit, setShouldShowEdit] = useState(false)

    const [src, setSrc] = useState(null)

    const photoInputRef = useRef<HTMLInputElement>(null)

    const {user, isAdmin, isAuthenticated} = useAuth()

    const {uid, photoUrl, username} = useSelector(state => state.userSession.currentProfile)

    const dispatch = useDispatch()


    const isAllowedToEdit = user?.uid === uid || isAdmin;

    useEffect(() => {

        if (isAllowedToEdit && !shouldShowEdit && isTouchDevice()) {
            setShouldShowEdit(true)
        }

    }, [isAllowedToEdit])

    const showEdit = () => {
        //only show edit if allowed
        setShouldShowEdit(isAllowedToEdit)

    }

    const hideEditUnlessTouch = () => {
        if (!isTouchDevice()) {
            setShouldShowEdit(false)
        }
    }

    const handleMouseEnter = (event: any) => {
        showEdit()
    }

    const handleMouseLeave = (event: any) => {
        hideEditUnlessTouch()
    }

    const handlePhotoCropAndUploadFinished = (url: string | null) => {

        if (!!url) {
            if (photoInputRef.current) photoInputRef.current.value = ""
        }

        setSrc(null)
        if (isAllowedToEdit && !!url) {
            dispatch(updateProfilePhoto(url))
        }
        hideEditUnlessTouch()
    }

    const onSelectFile = (e: any) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0]
            const reader = new FileReader()
            reader.addEventListener(
                "load",
                () =>
                    getOrientation(file, (orientationCode) => {

                        resetOrientation(reader.result || "", orientationCode, (rotatedDataUrl) => {
                            setSrc(rotatedDataUrl)
                        })
                    }),
                false
            )
            reader.readAsDataURL(e.target.files[0])
        }
    }


    return <Box
        style={{
            position: "absolute",
            top: -50,
            display: "block",
            borderRadius: "50%",
            backgroundColor: "white",
            width: 200,
            height: 200,
            zIndex: 100,
            left: "50%",
            marginLeft: -212 / 2,
            textAlign: "center"
        }}

        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}

    >

        <img src={photoUrl}
             style={{
                 borderRadius: "50%",
                 border: "6px solid white",
                 width: 200,
                 height: 200,
                 transition: ".2s ease-out",
                 ...(shouldShowEdit && {
                     boxShadow: "0px 0px 0px 3px #ccc",
                 }),
                 ...(!isAuthenticated && {
                     filter: "blur(5px) grayscale(100%)"
                 }),
             }}

             alt={username}/>

        <form
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                marginLeft: "85%",
                marginTop: "85%",
                transform: "translate(-50%, -50%)",
                color: "rgba(255,255,255,0.8)",
                cursor: "pointer",
                borderRadius: 2,
                padding: theme.spacing(1),
                fontSize: "0.8rem",
                fontWeight: 700,
                zIndex: 10000
            }}
        >
            <input
                ref={photoInputRef}
                accept='image/*'
                id='raised-button-file'
                type='file'
                style={{display: "none"}}
                onChange={onSelectFile}
            />

            <Fade mountOnEnter unmountOnExit in={shouldShowEdit}>
                <label htmlFor='raised-button-file'>
                    <IconButton style={{backgroundColor: "#ccc"}} onClick={(e) => {
                        photoInputRef?.current?.click()
                    }}>
                        <EditIcon/>
                    </IconButton>
                </label>
            </Fade>

        </form>

        <PhotoCropAndUploadDialog src={src} onFinished={handlePhotoCropAndUploadFinished}
                                  storageDestination={`user/${uid}/profile/profile_photo_${uid}.jpg`}
                                  circularCrop={true}
                                  aspect={1}/>


    </Box>

}
